import { useMemo } from "react";
import type { Property } from "@/hooks/useProperties";
import { useTenant } from "@/hooks/useTenant";
import { priceBoundsOf, type BrowseContext } from "@/lib/browseFilters";

/** The browse grammar's context for this site: its areas and the live price bounds. */
export function useBrowseContext(properties: readonly Pick<Property, "price">[]): BrowseContext {
  const tenant = useTenant();
  const { priceMin, priceMax } = useMemo(() => priceBoundsOf(properties), [properties]);
  return useMemo<BrowseContext>(
    () => ({ areaNames: tenant.areas, areaSlugs: tenant.areaSlugs, priceMin, priceMax }),
    [tenant.areas, tenant.areaSlugs, priceMin, priceMax],
  );
}
